import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-wrap content-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-md font-bold" }, "Create new playlist", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "tooltip" }, "Hide Form", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M5 15l7-7 7 7"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "tooltip" }, "Show Form", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "pb-12"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-red-600" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "text-green-600" }
const _hoisted_14 = { class: "pt-4" }
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_textarea = _resolveComponent("base-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.itemId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          (_ctx.showNewForm)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showNewForm = false)),
                class: "ml-2 cursor-pointer inline has-tooltip relative"
              }, [
                _hoisted_3,
                (_openBlock(), _createElementBlock("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: _normalizeClass(["h-6 w-6", 'w-5 h-5 text-blue-50 hover:text-gray-200 transition-colors duration-300 mt-0']),
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "svg-inline": '',
                  role: 'presentation',
                  focusable: 'false',
                  tabindex: '-1'
                }, _hoisted_5))
              ]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showNewForm = true)),
                class: "ml-2 cursor-pointer inline has-tooltip relative"
              }, [
                _hoisted_6,
                (_openBlock(), _createElementBlock("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: _normalizeClass(["h-6 w-6", 'w-5 h-5 text-blue-50 hover:text-gray-200 transition-colors duration-300 mt-0']),
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "svg-inline": '',
                  role: 'presentation',
                  focusable: 'false',
                  tabindex: '-1'
                }, _hoisted_8))
              ]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.showNewForm)
      ? (_openBlock(), _createElementBlock("form", _hoisted_9, [
          _createVNode(_component_base_input, {
            modelValue: _ctx.input.title,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.input.title) = $event)),
            label: "Playlist Title",
            class: "md:pl-8 md:pr-6",
            type: "text",
            errors: _ctx.v$.input.title.$errors,
            onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validate()))
          }, null, 8, ["modelValue", "errors"]),
          _createVNode(_component_base_textarea, {
            modelValue: _ctx.input.description,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.input.description) = $event)),
            label: "Playlist Description",
            placeholder: "Description",
            class: "md:pl-8 md:pr-6",
            rows: "1",
            errors: _ctx.v$.input.description.$errors,
            onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validate()))
          }, null, 8, ["modelValue", "errors"]),
          _createElementVNode("div", null, [
            (_ctx.createPlaylistErrors)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createPlaylistErrors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error[0]
                    }, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(error), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.createPlaylistSuccess)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.createPlaylistSuccess), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "btn btn-primary float-left has-tooltip relative",
                disabled: _ctx.disabled,
                onClick: [
                  _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.callCreatePlaylist && _ctx.callCreatePlaylist(...args))),
                  _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.disabled && _ctx.disabled(...args)), ["prevent"]))
                ]
              }, _toDisplayString(_ctx.itemId ? 'Add to New' : 'Create') + " Playlist ", 9, _hoisted_15)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}